<template>
    <picker
        minimum-view="year"
        :value="value"
        :default-date="defaultDate"
        :disabled-dates="disabledYears"
        format="yyyy"
        @input="input($event)">
    </picker>
</template>

<script>

import Picker from "../common/Picker";
// import Utils from '../mixins/UtilsMixin';
// No date or string spliting is done here (Why include never used stuff?)

export default {
    components : {"picker" : Picker},

    //mixins : [Utils],

    props : {

        defaultDate : {
            type : Date,
            default : new Date()
        },

        disabledYears : {
            type : Object, // you sure ? not an array of them?
        }

    },

    data() {
        return {
            value : this.defaultDate,
        };
    },

    methods : {

        input(event) {
            this.$emit("input", event);
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/common/YearPicker.vue